export default "__VITE_ASSET__D_Z3N_EF__"